import { useParamsContext } from '../../../contexts/ParamsContext';
import { ArrowLeftRight, ChartColumn, ChartLine, FlaskConical, Package } from 'lucide-react';

const navItems = [
    { key: 'overview', label: 'Visão Geral', icon: ChartLine, hint: 'Alertas e compras' },
    { key: 'items', label: 'Itens', icon: Package, hint: 'Catálogo e saldo' },
    { key: 'movement', label: 'Movimentação', icon: ArrowLeftRight, hint: 'Entrada e saída' },
    { key: 'recipes', label: 'Receitas', icon: FlaskConical, hint: 'Consumo por serviço' },
    { key: 'reports', label: 'Relatórios', icon: ChartColumn, hint: 'Consumo e custos' },
];

export default function EstoqueSubMenu() {
    const { action, setParams } = useParamsContext();
    const current = action || 'overview';
    const currentKey = current === 'detail' ? 'items' : current;

    return (
        <div className="flex flex-col">
            <div className="px-5 pb-2 pt-5 text-[11px] font-semibold text-base-content/45">Estoque</div>
            <div className="p-2">
                <ul className="menu gap-0.5 p-0">
                    {navItems.map((item) => {
                        const isActive = currentKey === item.key;
                        return (
                            <li key={item.key}>
                                <button
                                    type="button"
                                    className={`sf-menu-item flex min-h-10 w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-medium ${isActive ? 'is-active' : ''}`}
                                    onClick={() => setParams({ action: item.key, id: '' })}
                                    aria-current={isActive ? 'page' : undefined}
                                    title={item.hint}
                                >
                                    <item.icon className="sf-menu-item-icon" aria-hidden="true" />
                                    <span className="min-w-0 flex-1 truncate">{item.label}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
